import { render, staticRenderFns } from "./ModalGroupCreateInfo.vue?vue&type=template&id=6e5827f6&scoped=true"
import script from "./ModalGroupCreateInfo.vue?vue&type=script&lang=js"
export * from "./ModalGroupCreateInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupCreateInfo.vue?vue&type=style&index=0&id=6e5827f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5827f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5827f6')) {
      api.createRecord('6e5827f6', component.options)
    } else {
      api.reload('6e5827f6', component.options)
    }
    module.hot.accept("./ModalGroupCreateInfo.vue?vue&type=template&id=6e5827f6&scoped=true", function () {
      api.rerender('6e5827f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalGroupCreateInfo.vue"
export default component.exports